var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8List(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".aList{fill:var(--red-interaction-dark) !important;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aList",
    d: "M3,5V9H7V5Zm9,1a1,1,0,1,0,0,2H26a1,1,0,1,0,0-2ZM3,13v4H7V13Zm9,1a1,1,0,1,0,0,2H26a1,1,0,1,0,0-2ZM3,21v4H7V21Zm9,1a1,1,0,1,0,0,2H26a1,1,0,1,0,0-2Z",
    transform: "translate(-3 -5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8List);
export default __webpack_public_path__ + "static/media/icons8-list.6af779beffea3f3d60f5e3764d6e256e.svg";
export { ForwardRef as ReactComponent };